// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__2uia5","valueCheck":"Param_valueCheck__Ym8OD","valueCross":"Param_valueCross__w435a"};